var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.981,
    height: 13.413,
    viewBox: "0 0 16.981 13.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8666723_mail_icon",
    "data-name": "8666723_mail_icon",
    transform: "translate(-0.955 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20285",
    "data-name": "Path 20285",
    d: "M3.489,4H15.4a1.494,1.494,0,0,1,1.489,1.489v8.935A1.494,1.494,0,0,1,15.4,15.913H3.489A1.494,1.494,0,0,1,2,14.424V5.489A1.494,1.494,0,0,1,3.489,4Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20286",
    "data-name": "Path 20286",
    d: "M16.892,6,9.446,11.212,2,6",
    transform: "translate(0 -0.511)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMail);
export default __webpack_public_path__ + "static/media/footer-mail.58217ca13dabf0fb43ccee8bdd1d7f3a.svg";
export { ForwardRef as ReactComponent };